import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { apiConfig } from '@/config/tokenConfig';
import { type JwtPayload, jwtDecode } from 'jwt-decode';

export const useAccessToken = () => {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();

  const tokenRequest = {
    account: accounts[0],
    scopes: apiConfig.resourceScopes,
  };

  interface TToken extends JwtPayload {
    groups: string[];
  }

  const getSilentToken = async () => {
    if (!accounts[0]) {
      return null;
    }

    try {
      const tokenResponse = await instance.acquireTokenSilent(tokenRequest);
      const tokenDecoded: TToken = jwtDecode(tokenResponse.accessToken);
      localStorage.setItem('groups', JSON.stringify(tokenDecoded.groups));
      return tokenResponse.accessToken;
    } catch (e) {
      console.error('Silent token acquisition failed:', e);

      if (accounts[0]) {
        await instance.clearCache();
      }

      sessionStorage.setItem(
        'preAuthPath',
        window.location.pathname + window.location.search,
      );

      await instance.acquireTokenRedirect(tokenRequest);
      return null;
    }
  };

  useEffect(() => {
    instance.handleRedirectPromise().then((response) => {
      if (response) {
        const savedPath = sessionStorage.getItem('preAuthPath');
        if (savedPath) {
          sessionStorage.removeItem('preAuthPath');
          navigate(savedPath);
        }
      }
    });
  }, [instance, navigate]);

  return { getSilentToken };
};
